module.exports = __webpack_public_path__ + "img/thumbnail_ashigtai.c2adf38a.png";